import styled from 'styled-components';

import { buildSrc, useWgllBaseUrl, useWgllPath } from './helpers';

const StyledIframe = styled.iframe`
  height: calc(100vh - var(--headerOffset));
  width: 100%;
  overflow-y: auto;
  border: none;
`;

export const WgllLibrary: React.FC = () => {
  const path = useWgllPath('LIBRARY');
  const baseUrl = useWgllBaseUrl();
  return <StyledIframe allowFullScreen src={buildSrc(baseUrl, path)} title="WGLL Library" />;
};

export const OrgReadiness: React.FC = () => {
  const path = useWgllPath('ORG_READINESS');
  const baseUrl = useWgllBaseUrl();
  return <StyledIframe allowFullScreen src={buildSrc(baseUrl, path)} title="Org Readiness" />;
};
